/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 17:30:18
 * @LastEditTime: 2021-09-28 17:11:15
 * @LastEditors: wangshengqiang
 * @Description: 多计划中 每个计划项组件
 */
import React from 'react';
import classnames from 'classnames';
import { useStore } from '@/store';
const PlanTab = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    children,
    Render
  } = props;
  const planId = useStore('PLAN_ID');
  const cls = classnames({
    'components-plan-tab-render': true
  });
  children.forEach(item => {
    item.planId = attrs.planId;
  });
  const dangerouslySetInnerHTML = {
    __html: `
      .c-insure-plans::before {
        display: none !important;
      }

      .c-insure-plans::after {
        display: none !important;
      }
    `
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    ref: ref
  }, /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  }), /*#__PURE__*/React.createElement(Render, {
    components: children
  }));
});
export default PlanTab;